import Message from '@admin/components/message'
import PropTypes from 'prop-types'
import React from 'react'

class Purchase extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  _handleNext = this._handleNext.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return (
      <Message { ...this._getMessage() } />
    )
  }

  _getMessage() {
    return {
      svg: 'palette',
      title: 't(Configure Your Logo)',
      text: 't(Thank you for purchasing a logo design! To begin, please complete the Logo Intake Form. This form is the first step in your account setup and helps us understand your brand style, preferences, and vision. Your logo design will begin once your full setup is complete, including all required intake forms, branding details, and account configuration.)',
      buttons: [
        {
          label: 't(Start Form)',
          handler: this._handleNext
        }
      ]
    }
  }

  _handleNext() {
    this.props.onNext({})
  }

}

export default Purchase
